<template>
    <div>
        <el-form ref="forms" label-width="100px" class="forms-lines">
            <el-form-item label="商品属性">
                <el-select v-model="mx_value" placeholder="请选择" size="small" @change="getsxxx">
                    <el-option v-for="item in mx_options" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <div v-for="(item,index) in sxxxitem" :key="index">
                <div class="u-f">
                    <div class="mc">{{item.name}}</div>
                    <div v-if='item.type==0'>
                        <el-input v-model="item.value" size="samll" disabled placeholder="请输入内容"></el-input>
                    </div>
                    <div v-if='item.type==1'>
                        <el-radio-group v-model="radio">
                            <el-radio v-for="(items,indexs) in item.value.split(',')" :label='items' :key='indexs'>
                                {{items}}
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if='item.type==2'>
                        <el-checkbox-group v-model="checked">
                            <el-checkbox v-for="(items,indexs) in item.value.split(',')" :label="items" :key="indexs">
                                {{items}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div v-if='item.type==3'>
                        <el-select v-model="value" size="samll" placeholder="请选择">
                            <el-option  v-for="(items,indexs) in item.value.split(',')" :key="indexs" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-if='item.type==4'>
                         <el-input v-model="item.value" size="samll"  placeholder="请输入内容"></el-input>
                     </div>
                </div>

            </div>
        </el-form>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                mx_value: '',
                mx_options: [],
                sxxxitem: [],
                radio: '',
                checked: [],
                value:'',
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {

        },
        methods: {
            getsxxx() {
                axios
                    .post("/admin/ShopGoods/getModel", {
                        id: this.mx_value,
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.sxxxitem = response.data.data.result
                    })
                    .catch(error => {})
            },
        }
    }
</script>

<style scoped>
    .mc {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
    }
</style>